var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{staticClass:"overlay",attrs:{"value":_vm.overlay,"hide-overlay":false,"persistent":false,"retain-focus":true,"aria-hidden":false}},[_c('v-progress-circular',{attrs:{"color":"primary","indeterminate":"","size":"64","role":"progressbar","aria-label":"Loading"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }